import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {PREFFERED_LANGUAGE} from '@core/constants/localstorage-keys';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {TranslateService} from '@ngx-translate/core';
import {WicketUser} from '@tisa-group/models';
import {BehaviorSubject} from 'rxjs';

export type Language = NonNullable<WicketUser['preferred_language']>;
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  currentLanguage$ = new BehaviorSubject<Language>('');

  isInitialized$ = new BehaviorSubject<boolean>(false);

  constructor(
    readonly translateService: TranslateService,
    readonly titleService: Title,
    readonly router: Router,
    @Inject(DOCUMENT) readonly document: Document,
    @Inject(LOCAL_STORAGE) readonly localStorage: Storage,
  ) {}

  setLanguage(language: Language) {
    this.document.documentElement.lang = language;
    this.localStorage.setItem(PREFFERED_LANGUAGE, language);
    this.currentLanguage$.next(language);

    return this.translateService.use(language);
  }
}
